<template>
  <v-layout fluid>
    <v-layout column>
      <!-- <v-select
        v-if="holderType === 'student'"
        :items="classtypes"
        v-model="options.class_type"
        label="Select Class"
        item-text="class_type"
        item-value="_id"
      /> -->
      <v-text-field
        v-if="holderType === 'student' && hasParentGuardianOption"
        flat
        label="Parent Name"
        v-model="options.parent_name"
      ></v-text-field>
      <v-autocomplete
        v-if="holderType === 'contractor' || holderType === 'visitor'"
        v-model="options.appointment_user"
        :loading="loading"
        :items="appointmentUsers"
        :item-text="item => item.first_name + ' ' + item.last_name"
        :search-input.sync="appointmentUser"
        item-value="_id"
        cache-items
        flat
        hide-no-data
        hide-details
        label="Visit for"
        class="mb-2"
      ></v-autocomplete>
      <v-text-field
        v-if="type === 'signin'"
        flat
        label="Sign In Reason"
        v-model="options.sign_in_reason"
      ></v-text-field>
      <v-text-field
        v-else
        flat
        label="Sign Out Reason"
        v-model="options.sign_out_reason"
      ></v-text-field>
      <v-text-field
        flat
        label="Station"
        v-model="options.station"
      ></v-text-field>
      <v-layout
        row
        v-if="
          (holderType === 'contractor' || holderType === 'visitor') &&
            options.wwcc_card === 2 &&
            permissions.includes('wwcc')
        "
      >
        <v-text-field
          v-if="options.wwcc_card === 2"
          flat
          label="WWCC Number"
          v-model="options.wwcc_no"
        ></v-text-field>
        <v-btn v-if="options.wwcc_no && contact.last_name" @click="checkCardNo"
          >Check</v-btn
        >
      </v-layout>
      <!-- <v-select
        v-if="holderType === 'contractor' || holderType === 'visitor'"
        :items="policies"
        v-model="options.policies"
        label="Select Policies"
        item-text="policy"
        item-value="_id"
        multiple
      ></v-select>-->
      <v-layout
        column
        class="pt-2"
        v-if="holderType === 'contractor' || holderType === 'visitor'"
      >
        <!-- <v-label>Select Policies</v-label>
        <v-label></v-label> -->
        <!-- <v-label></v-label>
        <v-checkbox
          v-for="policy in policies"
          :key="policy._id"
          v-model="options.policies"
          :label="policy.policy"
          :value="policy._id"
          class="pa-0 ma-0"
        ></v-checkbox> -->
      </v-layout>
      <!-- <v-flex v-if="holderType === 'contractor' || holderType === 'visitor'">
        <VueSignaturePad
          id="signature"
          width="100%"
          height="150px"
          ref="signaturePad"
          :options="options"
        ></VueSignaturePad>
        <v-btn color="info" @click="clear">Clear</v-btn>
      </v-flex> -->
    </v-layout>
  </v-layout>
</template>

<script>
import APIWwcc from "@/mixins/APIWwcc";
import APIPolicies from "@/mixins/APIPolicies";
import APIResource from "@/mixins/APIResource";
import APIClassType from "@/mixins/APIClassType";
export default {
  props: {
    holderType: String,
    contact: {},
    type: String,
    value: {
      type: Object,
      default: function() {
        return {
          sign_in_reason: "",
          sign_out_reason: "",
          wwcc_card: 0,
          class_type: "",
          appointment_user: "",
          policies: [],
          parent_name: "",
          signature: "",
          wwcc_no: "",
          station: "Front Station"
        };
      }
    }
  },
  mixins: [APIPolicies, APIClassType, APIResource, APIWwcc],
  data() {
    return {
      options: this.value,
      loading: false,
      appointmentUser: "",
      wwccsvalid: false,
      appointmentUsers: [],
      policies: [],
      classtypes: []
    };
  },
  watch: {
    options: {
      handler: function(val) {
        this.$emit("input", val);
      },
      deep: true
    },
    contact: {
      handler: function(val) {
        if (val.class) {
          this.options.class_type = val.class._id;
        }
      },
      deep: true
    },
    holderType: {
      handler: function() {
        this.options = {
          sign_in_reason: "",
          sign_out_reason: "",
          wwcc_card: 0,
          class_type: "",
          appointment_user: "",
          policies: [],
          parent_name: "",
          signature: "",
          wwcc_no: "",
          station: "Front Station"
        };
        if (["visitor", "contractor"].includes(this.holderType)) {
          this.applyPolicies();
        } else {
          this.options.policies = [];
        }
      }
    }
  },
  created() {
    this.listPolicies();
    this.listClassTypes();
    this.searchStaff();
  },
  computed: {
    hasParentGuardianOption: function() {
      return this.user.company && this.user.company.company_sub_type === 1;
    }
  },
  methods: {
    applyPolicies: function() {
      this.options.policies = this.$store.state.policies.map(obj => {
        return obj._id;
      });
    },
    clear: function() {
      this.$refs.signaturePad.clearSignature();
    },
    checkCardNo: async function() {
      if (!this.options.wwcc_no) {
        this.$toast.error("WWCC number can not be empty!", "Error", {
          position: "topCenter"
        });
        return;
      }
      if (!this.contact.last_name) {
        this.$toast.error("Surname can not be empty!", "Error", {
          position: "topCenter"
        });
        return;
      }
      try {
        let checkStatus = {};
        checkStatus.card_no = this.options.wwcc_no;
        checkStatus.last_name = this.contact.last_name;
        let responce = await this.postVistorrCheck(checkStatus);
        if (responce.code === 420) {
          this.wwccsvalid = false;
          this.wwccResponse = responce;
          this.$toast.error(responce.message, "WWCC Error", {
            position: "topCenter"
          });
        } else {
          this.wwccResponse = responce;
          this.$toast.success(
            responce.message || "Successfully checked the WWCC status.",
            responce.message ? "" : "Success",
            { position: "topCenter" }
          );
          this.wwccsvalid = true;
        }
      } catch (error) {
        this.wwccsvalid = false;
        this.$toast.error(String(error), "", {
          position: "topCenter"
        });
      }
    },
    searchStaff: async function() {
      try {
        this.loading = true;
        let res = await this.allStaff();
        this.appointmentUsers = res;
        this.loading = false;
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    listPolicies: async function() {
      try {
        this.policies = await this.getPolicies();
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    listClassTypes: async function() {
      try {
        this.classtypes = await this.getClassTypes();
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }
  }
};
</script>

<style></style>
